import React from 'react';
import { MockStock } from '../types';
import { ReactComponent as SearchIcon } from '../../../assets/icons/search-line.svg';
import RicInputBox from '../../../Components/Common/RicInputBox/RicInputBox';
import './SearchBar.css';

interface SearchBarProps {
  selectedSymbol: string;
  onSelect: (stock: MockStock) => void;
  token?: string;
}

const SearchBar: React.FC<SearchBarProps> = ({ onSelect, token = '' }) => {
  const handleSelectOption = (option: any) => {
    const symbol = option.symbol ?? '';
    const name = option.name ?? '';
    onSelect({ symbol, name, exchange: '', price: 0, change: 0, changePct: 0 });
  };

  return (
    <div className="search-bar">
      <div className="search-bar-input-wrapper">
        <RicInputBox
          placeholder="Search by Ticker or Keyword"
          onSelectOption={handleSelectOption}
          token={token}
        />
      </div>
      <SearchIcon className="search-bar-icon" />
    </div>
  );
};

export default SearchBar;
